import { PageHeader } from '@/shared/components/PageHeader';
import { Wrench } from 'lucide-react';
import DisciplinesStep from '../components/DisciplinesStep';

export default function DisciplinesPage() {
  return (
    <>
      <PageHeader
        title="Disciplines"
        subtitle="Manage trades and disciplines"
        icon={<Wrench className="w-7 h-7" style={{ color: '#E84A2B' }} />}
      />
      <DisciplinesStep />
    </>
  );
}
